import { render, staticRenderFns } from "./AlbumController.vue?vue&type=template&id=71b6866a&scoped=true"
import script from "./AlbumController.vue?vue&type=script&lang=js"
export * from "./AlbumController.vue?vue&type=script&lang=js"
import style0 from "./AlbumController.vue?vue&type=style&index=0&id=71b6866a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6866a",
  null
  
)

export default component.exports